import PropTypes from 'prop-types';

import './styles/mediaObjectStyles.css';

const MediaObject = ({ children, ...rest }) => (
  <div className="media-object flex flex-row items-center" {...rest}>
    {children}
  </div>
);

MediaObject.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MediaObject;
